export const PROJECTS = [
	{
		id: 'tulsa',
		name: 'Tulsa Race Massacre',
		year: 1921,
		dates: 'May 31 – June 1, 1921',
		location: 'Tulsa, Oklahoma',
		neighborhood: 'Greenwood District',
		status: 'active',
		route: '/projects/tulsa',
		summary:
			'The destruction of "Black Wall Street" — one of the most prosperous Black communities in American history. Official death certificates number in the dozens; historians estimate 100–300 killed. For over a century, the people who were killed have remained unnamed and uncounted.',
		context:
			'A white mob, with state assistance, destroyed 35 blocks of the Greenwood District. Death certificates were withheld. The official record was suppressed. CDM applies census disruption analysis to identify prime-age Black Tulsans who vanish from the historical record after May 1921.',
		stats: [
			{ n: '1.7M+', l: 'Records analyzed' },
			{ n: '1,739', l: 'In risk pool' },
			{ n: '878', l: 'Households mapped' },
		],
		dataLinks: [
			{ to: '/projects/tulsa/explore', label: 'Explore Data →' },
			{ to: '/projects/tulsa/heatmap', label: 'View Heatmap →' },
		],
	},
	{
		id: 'elaine',
		name: 'Elaine Massacre',
		year: 1919,
		dates: 'September 30 – October 2, 1919',
		location: 'Elaine, Arkansas',
		neighborhood: 'Phillips County',
		status: 'in-progress',
		route: '/projects/elaine',
		summary:
			'Black sharecroppers in Phillips County organized to negotiate better wages. A white mob, joined by federal troops, responded with mass violence. Estimates suggest over 100 Black people were killed — and five white men — while hundreds of Black residents were arrested and dozens tried for murder.',
		context:
			'The Elaine Massacre is one of the deadliest episodes of racial violence in American history, yet it remains largely absent from national memory. CDM will adapt its census disruption methodology to identify prime-age Black residents of Phillips County who disappear from the record after September 1919.',
	},
	{
		id: 'rosewood',
		name: 'Rosewood Massacre',
		year: 1923,
		dates: 'January 1–7, 1923',
		location: 'Rosewood, Florida',
		neighborhood: 'Levy County',
		status: 'in-progress',
		route: '/projects/rosewood',
		summary:
			'A predominantly Black town in rural Florida was attacked and burned to the ground by a white mob following a false accusation. Survivors fled into surrounding swamps. The town of Rosewood ceased to exist. The full death toll has never been established.',
		context:
			'Florida conducted a formal investigation in 1994 and survivors received reparations — one of the few such cases in U.S. history. CDM will apply census linkage analysis to the 1920 Rosewood community to identify individuals whose historical continuity was severed in January 1923.',
	},
];

export const getProject = (id) => PROJECTS.find((p) => p.id === id);
